var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-6 w-48 bg-gray-200 rounded animate-pulse"})
}
var staticRenderFns = []

export { render, staticRenderFns }